<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col col lg="6">
        <b-alert variant="success" :show="$route.meta.showValidationAlert">
          {{ $t('login.validate_account') }}
        </b-alert>
        <b-alert variant="success" :show="$route.meta.showValidatedAlert">
          {{ $t('login.validated_account') }}
        </b-alert>
        <b-alert variant="danger" :show="isLoginError">
          {{ $t(errorMessage) }}
        </b-alert>
        <b-form @submit="doLogin" v-if="show">
          <b-form-group
            id="group1"
            class="text-left"
            :label="$t('login.email_label')"
            label-for="mailinput"
            :invalid-feedback="form_invalid_feedback.email"
          >
            <b-form-input
              id="mailinput"
              v-model.trim="form.email"
              type="text"
              required
              autocomplete="username email"
              :state="form_state.email"
              :placeholder="$t('login.email_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="group2"
            class="text-left"
            :label="$t('login.password_label')"
            label-for="passinput"
          >
            <b-form-input
              id="passinput"
              v-model="form.password"
              type="password"
              :state="form_state.password"
              autocomplete="current-password"
              required
              :placeholder="$t('login.password_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-row class="text-left">
            <b-col cols="12" md="6">
              <b-form-group id="group3" class="text-left">
                <b-form-checkbox-group v-model="form.stay_logged" id="loginchecks">
                  <b-form-checkbox>{{ $t('login.stay_logged') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="text-right">
              <div>
                <router-link :to="{name: 'recover_pass'}">{{ $t('login.recover_link') }}</router-link>
              </div>
            </b-col>
          </b-row>

          <b-row class="text-left mt-5">
            <b-col cols="12" md="6">
              <b-button
                type="submit"
                variant="primary-b"
                size="xl"
              >{{ $t('login.submit_button') }}</b-button>
            </b-col>
            <b-col>
              <div class="social-box h-100 d-flex align-items-center">
                <router-link :to="{name: 'social_auth', params: { provider: 'facebook' } }">
                  <FB class="mr-2" thumbnail alt="Facebook" />
                </router-link>
                <router-link :to="{name: 'social_auth', params: { provider: 'twitter' } }">
                  <TW class="mr-2" thumbnail alt="Twitter" />
                </router-link>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <b-row class="text-left mt-3">
          <b-col cols="12" md="6">
            <router-link :to="{name: 'register'}">{{ $t('login.register_link') }}</router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import FB from "@/static/social/fb.svg";
import TW from "@/static/social/tw.svg";

export default {
  name: "login",
  components: {
    FB,
    TW,
  },
  data() {
    return {
      isLoginError: false,
      errorCode: "",
      form: {
        email: "",
        password: "",
        stay_logged: [],
      },
      form_invalid_feedback: {},
      form_state: {},
      show: true,
    };
  },
  computed: {
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
    errorMessage() {
      if (this.errorCode == "social-5") {
        return "login.error.no_mail_provided";
      } else {
        return "login.error.feedback";
      }
    },
  },
  mounted: function() {
    if (this.$route.meta.error) {
      this.isLoginError = true;
      this.errorCode = this.$route.query.code;
    }
  },
  fallbackI18n: {
    messages: {
      und: {
        login: {
          accept_legal_checkbox: "I accept the EULA / Legal terms & conditions",
          email_label: "Email",
          password_placeholder: "Enter password",
          email_placeholder: "Enter email",
          password_label: "Password:",
          register_link: "I dont have account, register",
          recover_link: "I dont remember my password",
          submit_button: "Login",
          stay_logged: "Stay Logged In",
          login_with_social: "Log in with",
          subtit:
            "Welcome to your private area as a patient user of the MEDIKA Online platform.",
          access: "ACCESS",
          validate_account:
            "We have sent an email with a confirmation link to your email address. Please allow 5-10 minutes for this message to arrive.",
          validated_account: "Account validated. Please, login.",
          error: {
            feedback: "Unable to log in with provided credentials.",
            no_mail_provided:
              "No email was provided from this social network account.",
            get_main_patient: "Unable to get main patient",
          },
        },
      },
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    doLogin(evt) {
      this.isLoginError = false;
      this.errorCode = "";
      evt.preventDefault();
      var data = this.form;
      this.$store.dispatch("auth/LOGIN", { data: data }).then(
        () => {
          this.$store.dispatch("auth/ME");
          this.$store.dispatch("naturalperson/REQUEST_DOCTOR");
          this.$store.dispatch("naturalperson/GET_MAIN_PATIENT", {}).then(
            response => {
              // Si el usuario no tiene pacientes le redirigimos para que cree uno
              if (response.data.uuid) {
                this.$emit("login-done", {
                  error: false,
                  pt_uuid: response.data.uuid,
                });
              } else {
                this.$emit("login-done", {
                  error: false,
                  pt_uuid: undefined,
                });
              }
            },
            err => {
              this.mnotify_error({
                text: this.$t("login.error.get_main_patient"),
                debug: err,
              });
              this.$emit("login-done", {
                error: true,
                pt_uuid: undefined,
              });
            }
          );
        },
        err => {
          this.isLoginError = true;
          // this.showResponseError(err);
          this.putFormFeedback(err.response);
        }
      );
    },
  },
};
</script>


<style lang="scss" scoped>
.social-box {
  svg {
    width: 26px;
    height: 26px;
  }
}
</style>
